import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.75} y={0.75} width={34.5} height={22.5} fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 17.5589V20.1214H32.7458L31.5432 18.7144L30.2935 20.1214H21.0498V12.6306H18L21.8123 4H25.5223L26.4183 5.9572V4H31.0245L31.7948 6.05153L32.5493 4H36V5.21833H33.3354L32.1249 8.40962L31.8026 9.27422L30.2542 5.21833H27.5895V11.5065L24.8227 5.21833H22.6769L19.8943 11.5065H21.7179L22.2053 10.2961H25.2551L25.7424 11.5065H27.5895H29.193V7.41135L29.1852 6.58601L29.4996 7.41135L31.0323 11.5065H32.5572L34.0978 7.41135L34.3965 6.59388V11.5065H36V13.9668L34.2236 15.7511L36 17.5589ZM22.3389 18.903V12.6384H27.5895V13.9982H23.9424V15.0987H27.5188V16.4507H23.9424V17.5432H27.5895V18.903H22.3389ZM35.5127 18.903H33.4297L31.5275 16.8594L29.6175 18.903H27.5895L30.5214 15.7825L27.5895 12.6384H29.6804L31.5668 14.6742L33.4612 12.6384H35.5127L32.5729 15.7589L35.5127 18.903Z"
        fill="#016FD0"
      />
      <path
        d="M23.7301 6.56244L23.4158 7.34849L22.7633 8.93622H24.6969L24.0446 7.34849L23.7301 6.56244Z"
        fill="#016FD0"
      />
      <rect
        x={0.75}
        y={0.75}
        width={34.5}
        height={22.5}
        stroke="#CBD5E1"
        strokeWidth={1.5}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-amex" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
